module.exports = __webpack_public_path__ + "6426eca19663450bddca6c6f22628d57.svg";